import { render, staticRenderFns } from "./ReceiptFlow.vue?vue&type=template&id=a79ea036&scoped=true&"
import script from "./ReceiptFlow.vue?vue&type=script&lang=js&"
export * from "./ReceiptFlow.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptFlow.vue?vue&type=style&index=0&id=a79ea036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79ea036",
  null
  
)

export default component.exports